import React, { useState } from "react";
import { useSelector } from "react-redux";
import { testCampaign } from "api/CampaignApi";
import { toast } from "react-toastify";

export default function CampaignTest() {
  const [isTestSuccess, setIsTestSuccess] = useState(false);
  const { campaignId, campignTemplateId } = useSelector(
    (state) => state.campaignSetter
  );
  const { userEmail } = useSelector((state) => state.userSetter);

  const testApi = () => {
    if (campaignId && campignTemplateId) {
      testCampaign(campaignId)
        .then((data) => {
          setIsTestSuccess(true);
        })
        .catch((err) => {
          setIsTestSuccess(false);
        });
    } else {
      toast.info("Design a Template First!");
    }
  };

  return (
    <div className="row justify-content-between align-items-end pt_15">
      <div className="left_sec">
        <div className="max534">
          <label>Test</label>
          <p className="campaign_text">
            A test email will be sent to &nbsp;{" "}
            <span style={{ color: "blue" }}>{userEmail}</span>
          </p>
        </div>
      </div>
      <div className="right_sec">
        {/* style={{ outline: 'none !important', textDecoration: 'bold', color: 'white' }} */}
        <input
          to=""
          onClick={(e) => {
            testApi();
          }}
          name="testButton"
          value="Test"
          type="submit"
          className="lg_btn primary"
        />

        {isTestSuccess && <p style={{ color: "green" }}>Test Email Sent ✔</p>}
      </div>
    </div>
  );
}
